import React, { useState, useEffect } from "react";

//STYLES
import * as ControllerStyles from "../styles/controller";

//COMPONENTS
import GrowMenuItem from "./growMenuItem";

function GrowMenu() {
    const [menuHeight, setMenuHeight] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        if (menuOpen) {
            setMenuHeight(120);
        } else {
            setMenuHeight(0);
        }
    }, [menuOpen]);

    function handleOnEnter() {
        setMenuOpen(true);
    }

    function handleOnLeave() {
        setMenuOpen(false);
    }

    return (
        <div>
            <div style={ControllerStyles.menu_GrowMenuTopButton} onMouseEnter={handleOnEnter} onMouseLeave={handleOnLeave}></div>
            <div
                style={{ ...ControllerStyles.menu_GrowMenuAnimation, height: `${menuHeight}px` }}
                onMouseEnter={handleOnEnter}
                onMouseLeave={handleOnLeave}
            >
                <GrowMenuItem title="Item 1" />
                <GrowMenuItem title="Item 2" />
                <GrowMenuItem title="Item 3" />
                <GrowMenuItem title="Item 4" />
            </div>
        </div>
    );
}

export default GrowMenu;
